import { useFeatureNutrition } from 'hooks/use-feature-nutrition';
import { useLocale } from 'state/intl';
import { useFlag } from 'utils/launchdarkly';

import { Joule, RoundingFunction } from './types';

export function useFormatJoules(): (
  cal?: number,
  suffix?: string,
  roundingFunction?: RoundingFunction
) => string {
  const { locale } = useLocale();
  const { roundNutritionValue } = useFeatureNutrition();
  const enableFeatureNutritionIntergration = useFlag('enable-feature-nutrition-integration');

  const oldRoundingMethod: RoundingFunction = Math.floor;

  const defaultRoundingMethod: RoundingFunction = enableFeatureNutritionIntergration
    ? roundNutritionValue
    : oldRoundingMethod;

  return function formatJoules(
    cal?: number,
    suffix?: string,
    roundingFunction: RoundingFunction = defaultRoundingMethod
  ): string {
    if (cal === undefined || isNaN(cal)) {
      return '';
    }

    const jouleStr = suffix !== 'none' ? Joule.UNIT : '';
    return `${roundingFunction(cal * Joule.CONVERSION).toLocaleString(locale)} ${jouleStr}`.trim();
  };
}
